var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.0586L12.972 12.0306C14.1803 10.58 14.7828 8.71952 14.6542 6.83605C14.5256 4.95259 13.6759 3.19121 12.2817 1.91831C10.8876 0.645413 9.05634 -0.0409893 7.16898 0.00189494C5.28163 0.0447792 3.48346 0.813648 2.14855 2.14855C0.813648 3.48346 0.0447792 5.28163 0.00189494 7.16898C-0.0409893 9.05634 0.645413 10.8876 1.91831 12.2817C3.19121 13.6759 4.95259 14.5256 6.83605 14.6542C8.71952 14.7828 10.58 14.1803 12.0306 12.972L17.0586 18L18 17.0586ZM1.35538 7.34744C1.35538 6.16232 1.70681 5.00382 2.36522 4.01843C3.02364 3.03304 3.95947 2.26502 5.05438 1.8115C6.14928 1.35797 7.35409 1.23931 8.51643 1.47051C9.67878 1.70172 10.7465 2.27241 11.5845 3.11041C12.4225 3.94842 12.9932 5.0161 13.2244 6.17845C13.4556 7.34079 13.3369 8.5456 12.8834 9.6405C12.4299 10.7354 11.6618 11.6712 10.6765 12.3297C9.69106 12.9881 8.53256 13.3395 7.34744 13.3395C5.75879 13.3377 4.23571 12.7059 3.11236 11.5825C1.98901 10.4592 1.35714 8.9361 1.35538 7.34744Z",
    fill: "#AD2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9b3216259a4df40cf8631b8c68986d2e.svg";
export { ForwardRef as ReactComponent };